import { createAction } from 'redux-actions';
import { SET_REALTIME_SORT_ORDER } from '../constants/actionTypes';
export const setRealtimeSortOrder = createAction(SET_REALTIME_SORT_ORDER, sortOrder => ({
  sortOrder
}));